import { TransportError } from 'src/common/data/errors';
import type { TransportResponse } from 'src/common/data/types';
import { api } from './apiSingleton';

const PRODUCTS_ENDPOINT = 'subscription.getProductsBySkus';
const COUPON_ENDPOINT = 'subscription.lookupCoupon';
const SUBSCRIPTION_ENDPOINT = 'subscription.getSubscription';

function mapError(error: unknown, endpoint: string): TransportError {
  const status =
    typeof error === 'object' && error !== null && 'status' in error
      ? Number((error as { status?: unknown }).status)
      : undefined;

  return new TransportError({
    type: status && status >= 500 ? 'Upstream' : 'Unknown',
    status,
    retryable: !status || status >= 500,
    endpoint,
    cause: error,
  });
}

export default class ClientDataFetchingTransport {
  async getProductsBySkus(params: Record<string, unknown>): Promise<TransportResponse<unknown>> {
    try {
      const data = await api.fetch({
        url: '/api/v1/products/list/',
        params,
        skipCamelCaseTransform: true,
      });

      return { data };
    } catch (error) {
      throw mapError(error, PRODUCTS_ENDPOINT);
    }
  }

  async lookupCoupon({
    couponCode,
    ...params
  }: { couponCode: string } & Record<string, unknown>): Promise<
    TransportResponse<Record<string, unknown>>
  > {
    try {
      const data = await api.fetch<Record<string, unknown>>({
        url: `/api/v1/coupons/${couponCode}/`,
        params,
        skipCamelCaseTransform: true,
      });

      return { data };
    } catch (error) {
      throw mapError(error, COUPON_ENDPOINT);
    }
  }

  async getSubscription(
    params: Record<string, unknown>,
  ): Promise<TransportResponse<Record<string, unknown>>> {
    try {
      const data = await api.fetch<Record<string, unknown>>({
        url: '/api/v1/subscriptions/get/',
        params,
      });

      return { data };
    } catch (error) {
      throw mapError(error, SUBSCRIPTION_ENDPOINT);
    }
  }
}
